
export const useSmallWidth = 1700;
export const useExtraSmallWidth = 1278;

export const navigationOpenWidth = 200;
export const navigationClosedWidth = 40;
export const referenceSmallOpenWidth = 420;
export const referenceLargeOpenWidth = 548;
export const referenceClosedWidth = 20;
